<!-- Source的滚动列表 -->
<template>
    <div
      class="PTemplateListWrap"
      v-scroll="bindPTemplateScroll">
      <ul class="draggable_box PTemplateItem">
        <li
          :class="['draggable_item', 'TemplateFile', {'pitchOnItem': PitchTemplate == item.id + item.name}]"
          @click="getCheck(item)"
          v-for="(item, index) in TemplateData"
          :key="index"
          draggable="true"
          :data-target="'source' + index"
          :data-programtemplate="'programtemplate'"
          :data-device="JSON.stringify(item)">
          <div class="templateName"> {{ item.templateName }}</div>
          <div class="icon">
            <i
              :disabled="CloneDisabled.disableButton"
              class="el-icon-edit-outline"
              @click.stop="OperateTemplate(item,1)"></i>
            <i
              class="el-icon-delete"
              :disabled="CloneDisabled.disableButton"
              v-if="TemplateType != 'AmazonS3Templates'"
              @click="OperateTemplate(item,0)"></i>
          </div>
        </li>
        <div class="NoData" v-if="TemplateData.length == 0">
          {{$t('lang.noData')}}
        </div>
      </ul>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PTemplateScrollLoad',
  props: {
    TemplateData: {
      type: Array,
      default: () => {
        return []
      }
    },
    TemplateType: {
      type: String // NativeTemplates,AmazonS3Templates
    }
  },
  data () {
    return {
      // PTemplate绑定滚动事件
      bindPTemplateScroll: {
        onScroll: this.bindPTemplateScrollHandle,
        distance: 10,
        directive: '.PTemplateItem'
      },
      // 选中的模板
      PitchTemplate: ''
    }
  },
  computed: {
    ...mapState({
      CloneDisabled: (state) => state.playout.CloneDisabled
    })
  },
  created () {
  },
  mounted () {

  },
  methods: {
    // 滚动加载
    bindPTemplateScrollHandle () {
      this.$emit('ScrollUpdateTemplate', this.TemplateType)
    },
    // 点击source
    getCheck (item) {
      this.PitchTemplate = item.id + item.name
    },
    // 操作模板
    OperateTemplate (item, type) {
      if (this.CloneDisabled.disableButton) return
      item.TemplateType = this.TemplateType
      if (type) {
        this.$emit('editTemplate', item)
      } else {
        this.$emit('deleteTemplate', item)
      }
    }
  }
}
</script>

<style scoped lang="less">
.PTemplateListWrap {
  padding-bottom: 10px;
  .PTemplateItem {
    max-height: 260px;
    overflow-y: auto;
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    padding-left: 15px;
    margin: 0;
    .TemplateFile {
      width: 100%;
      height: 28px;
      background: #444444;
      box-sizing: border-box;
      padding: 0 0 0 8px;
      font-size: 12px;
      color: #cccccc;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .templateName{
        width: 70%;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 28px;
      }
      .icon{
        width: 30%;
        display: none;
        text-align: right;
        i{
          font-size: 16px;
          margin-right: 8px;
        }
      }
    }
    .TemplateFile:hover .icon{
      display: block;
    }
    .pitchOnItem {
      background: #3f5d46;
    }
  }
  .NoData{
    width: 100%;
    color: #dfdfdf;
    text-align: center;
  }
}
</style>
